import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

import {
  selectActiveEpisodeId,
  selectToasts,
  uiActions,
  useAppDispatch,
  useAppSelector,
} from '@/store';

import { ANIMATION_MS, Toast as ToastComponent } from './Toast.component';

const AUTO_HIDE_MS = 3000;
const FAST_HIDE_MS = 100;

export const Toast = () => {
  const dispatch = useAppDispatch();

  const toasts = useAppSelector(selectToasts);
  const activeEpisodeId = useAppSelector(selectActiveEpisodeId);
  const currentToast = toasts[toasts.length - 1];
  const autoHideMs = toasts.length > 1 ? FAST_HIDE_MS : AUTO_HIDE_MS;

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!currentToast?.id) return;

    const enterFrame = requestAnimationFrame(() => setIsVisible(true));
    const hideTimer = setTimeout(() => setIsVisible(false), autoHideMs);
    const removeTimer = setTimeout(() => {
      dispatch(uiActions.removeToast(currentToast.id));
    }, autoHideMs + ANIMATION_MS);

    return () => {
      cancelAnimationFrame(enterFrame);
      clearTimeout(hideTimer);
      clearTimeout(removeTimer);
    };
  }, [dispatch, currentToast?.id, autoHideMs]);

  if (!currentToast) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: ({ dimensions }) =>
          activeEpisodeId ? dimensions.miniPlayer.height : 0,
        left: 0,
        right: 0,
        zIndex: 'featureAnnouncement',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        pointerEvents: 'none',
      }}>
      <ToastComponent
        key={currentToast.id}
        isVisible={isVisible}
        variant={currentToast.variant}
        message={currentToast.message}
      />
    </Box>
  );
};
